import { GetPastConferencesDataType } from '@/api/conference';
import { Gallery, Newsletter, Notice, Trend } from '@/api/notice';

export interface ColumnDef {
	key: string;
	title: string;
}

// 각 타입에 맞는 Key 매핑
const COLUMN_MAP = {
	title: ['gallery_title', 'notice_title', 'newsletter_title', 'trend_title', 'guide_title'],
	hit: ['gallery_hit', 'notice_hit', 'newsletter_hit', 'trend_hit', 'guide_hit'],
	enrollment_date: ['gallery_enrollment_date', 'notice_enrollment_date', 'newsletter_enrollment_date', 'trend_enrollment_date', 'guide_enrollment_date'],
	admin: ['admin_name'],
};

// 타입별 동적 컬럼 생성 함수
export const generateColumns = (data: (Gallery | Notice | Newsletter | Trend | GetPastConferencesDataType)[]): ColumnDef[] => {
	if (data.length === 0) return [];

	// 현재 데이터 배열에서 사용 가능한 key 확인
	const sample = data[0];

	// 사용 가능한 key를 동적으로 선택
	const getAvailableKey = (keys: string[]) => keys.find((key) => key in sample) || '';

	return [
		{ key: 'no', title: 'NO.' },
		{ key: getAvailableKey(COLUMN_MAP.title), title: '제목' },
		{ key: getAvailableKey(COLUMN_MAP.admin), title: '작성자' },
		{ key: getAvailableKey(COLUMN_MAP.hit), title: '조회수' },
		{ key: getAvailableKey(COLUMN_MAP.enrollment_date), title: '작성일' },
	].filter((col) => col.key); // key가 없는 경우 제거
};
